"use strict";exports.stringRepeat=function(n,r){if(r<0)throw new RangeError("Invalid count value. Count must be a non-negative number.");return Array(Math.floor(r+1)).join(n)};
//# sourceMappingURL=stringRepeat.cjs.map
